import { Loader } from '@googlemaps/js-api-loader'
import { debounce } from '../utils/_debounce'
import { Scroll } from '../utils/_smooth-scroll'

/* global main_theme_objects, google */

const $ = jQuery

export default function MuseumsMaps () {
  const WRAPPERS = document.querySelectorAll('.mtt-museums-map')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const museumsMap = new MuseumMap(WRAPPERS[i])
      museumsMap.init()
    }
  }
}

class MuseumMap {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.MAP = this.WRAPPER.querySelector('.mtt-museums-map__map')
    this.MUSEUMS_WRAPPER = this.WRAPPER.querySelector('.mtt-museums-map__museums')
    this.MUSEUMS = this.WRAPPER.querySelectorAll('.mtt-museums-map__museum')

    this.apiKey = main_theme_objects.google_maps_api_key

    this.center = {
      lat: parseFloat(this.MAP.getAttribute('data-lat') ?? 57.0745452),
      lng: parseFloat(this.MAP.getAttribute('data-lng') ?? 4.4180293)
    }
    this.mobileCenter = {
      lat: parseFloat(this.MAP.getAttribute('data-lat-mobile') ?? 56.331217612898016),
      lng: parseFloat(this.MAP.getAttribute('data-lng-mobile') ?? 9.3772379335693)
    }
    this.zoom = parseInt(this.MAP.getAttribute('data-zoom') ?? 5)

    this.screenWidth = this.getScreenWidth()
  }

  init () {
    this.MUSEUMS.length > 0 && this.addMap()
  }

  addMap () {
    this.loader = new Loader({
      apiKey: this.apiKey,
      version: 'weekly'
    })

    this.loader.load().then(() => {
      this.googleMap = new google.maps.Map(this.MAP, {
        center: this.center,
        zoom: this.zoom,
        mapId: 'cc8c6b86d0aa26cc',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      })

      // Add custom panToWithOffset
      google.maps.Map.prototype.panToWithOffset = function (latLng, offsetX, offsetY) {
        const map = this
        const ov = new google.maps.OverlayView()
        ov.onAdd = function() {
          const proj = this.getProjection()
          const aPoint = proj.fromLatLngToContainerPixel(latLng)
          aPoint.x = aPoint.x + offsetX
          aPoint.y = aPoint.y + offsetY
          map.panTo(proj.fromContainerPixelToLatLng(aPoint))
        }
        ov.draw = function() {}
        ov.setMap(this)
      }

      this.addMarkers()
      this.updateCenter()
    })
  }

  updateCenter () {
    window.addEventListener('resize', debounce(() => {
      if (this.screenWidth !== this.getScreenWidth()) {
        this.googleMap.setCenter(this.getCenter())
        this.screenWidth = this.getScreenWidth()
      }
    }, 300))
  }

  getCenter () {
    if (this.getScreenWidth() > 1160) {
      return this.center
    }
    return this.mobileCenter
  }

  addMarkers () {
    const MAP = this.googleMap

    for (let i = 0; i < this.MUSEUMS.length; i++) {
      const MUSEUM = this.MUSEUMS[i]
      const MARKER_DATA = MUSEUM.getAttribute('data-marker')
      let hasSet = false

      const MARKER = this.createMarker(JSON.parse(MARKER_DATA))
      if (MARKER) {
        MARKER.addListener('click', () => this.clickMarker(MARKER))
        MARKER.setMap(MAP)

        if (i === 0) {
          MAP.addListener('tilesloaded', () => {
            if (!hasSet) {
              this.setActiveMarker(this.getCustomMarkers(0))
              hasSet = true
            }
          })
        }
      }
    }
  }

  createMarker ({ lat, lng, title, id, icon }) {
    if (!lat && !lng) return null

    return new google.maps.Marker({
      position: { lat: parseFloat(lat), lng: parseFloat(lng) },
      dataset: {
        test: 123
      },
      icon: {
        url: icon,
        scaledSize: new google.maps.Size(22, 22),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(11, 11)
      },
      id: id
    })
  }

  clickMarker (MARKER) {
    this.googleMap.panToWithOffset({ lat: MARKER.position.lat(), lng: MARKER.position.lng() }, this.getOffsetX(), 0)
    this.setActiveMuseum(MARKER)
    this.setActiveMarker(this.getCustomMarkers(MARKER.id))
    if (this.getScreenWidth() <= 1160) Scroll($(this.MUSEUMS_WRAPPER))
  }

  getCustomMarkers (id) {
    const CUSTOM_MARKERS = document.querySelectorAll('.gm-style img[src="https://maps.gstatic.com/mapfiles/transparent.png"]')
    if (CUSTOM_MARKERS.length > 0) {
      return CUSTOM_MARKERS[id].parentElement
    }
  }

  getOffsetX () {
    const screenWidth = this.getScreenWidth()
    if (this.MUSEUMS_WRAPPER && screenWidth > 1161) {
      const rect = this.MUSEUMS_WRAPPER.getBoundingClientRect()
      const left = rect.width + rect.left
      const remaining = screenWidth - left // calculate width of visible part of the map
      const leftCenter = left + remaining / 2 // calculate leftCenter of visible part of the map
      return (leftCenter - (screenWidth / 2)) * -1 // calculate offset from leftCenter
    }
    return 0
  }

  setActiveMarker (MARKER) {
    if (MARKER) {
      const SIBLINGS = MARKER.parentElement.querySelectorAll('div')
      if (SIBLINGS.length > 0) {
        for (let i = 0; i < SIBLINGS.length; i++) {
          const SIBLING = SIBLINGS[i]
          SIBLING.classList.remove('museum-map-pin-animation')
        }
      }
      MARKER.classList.add('museum-map-pin-animation')
    }
  }

  setActiveMuseum (MARKER) {
    for (let i = 0; i < this.MUSEUMS.length; i++) {
      const MUSEUM = this.MUSEUMS[i]
      const MUSEUM_ID = parseInt(MUSEUM.getAttribute('data-museum-id'))
      if (MUSEUM_ID === MARKER.id) {
        MUSEUM.classList.add('mtt-museums-map__museum--active')
      } else {
        MUSEUM.classList.remove('mtt-museums-map__museum--active')
      }
    }
    const SCROLL_CONTAINER = document.querySelector('.mtt-museums-map__museums--scroll-container')
    const ACTIVE_MUSEUM = document.querySelector('.mtt-museums-map__museum--active')
    const ACTIVE_TOP = ACTIVE_MUSEUM.offsetTop
    SCROLL_CONTAINER.scrollTop = ACTIVE_TOP - SCROLL_CONTAINER.offsetTop
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}